import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { EServiceId, IPublishTermsService } from '../../redux/reducers';

export const selectServiceById = curry((serviceId: EServiceId, state: IAppState): IPublishTermsService | null => {
  const {
    publishTerms: { services },
  } = state;

  return services[serviceId] || null;
});
